/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
import PopupMessage from 'material/message/popup/popup_container';



/* ========== ~~~~~~~~~~ MESSAGE : POPUP : ONINACTIVITYMESSAGE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// also receives two call back functions to route user
// this child component handles local state and uses props passed from parent to read/write application state when necessary
// Message specific component.
const OnInActivityMessage = (props) => (
    <PopupMessage
        type={'extendsession'}
        title={'We haven’t seen any activity in a while: are you still there?'}
        buttonPrimary={{ text: 'Yes', variant: 'primary', action: props.primaryAction }}
    />
);



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default OnInActivityMessage;